import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import ScopeToggle from "../../components/ScopeToggle";
import MyLeavesPage from "./MyLeavesPage";
import TeamLeavesPage from "./TeamLeavesPage";
import AllLeavesPage from "./AllLeavesPage";
// Both manager tiers apply for their own leave, so they get a My/Team switch.
import { SELF_SERVICE_MANAGERS } from "../../lib/roleOptions";

export default function LeavesRouter() {
  const { user } = useAuth();
  const role = user?.role;
  const [scope, setScope] = useState("team");

  if (role === "sales_officer") return <MyLeavesPage />;

  if (SELF_SERVICE_MANAGERS.includes(role)) {
    return (
      <div className="space-y-6">
        <ScopeToggle scope={scope} onChange={setScope} testIdPrefix="leaves" />
        {scope === "me" ? <MyLeavesPage soId={user.id} /> : <TeamLeavesPage />}
      </div>
    );
  }

  return <AllLeavesPage />;
}
